import { LogEntriesImageUploadModal } from '@monorepo/logs/src/components/LogEntriesReviewModal/LogEntriesImageUploadModal';
import React, { useCallback, useState } from 'react';
import {
  LogEntriesSelectUploadTypeModal,
  UploadType,
} from './LogEntriesSelectUploadTypeModal';
import { LogEntriesUploadCsvModal } from './LogEntriesUploadCsvModal';

type LogEntriesUploadModalProps = {
  logId: string;
  isOpen: boolean;
  onClose: () => void;
  organizationId: string;
  projectId: string;
};

export function LogEntriesUploadModal({
  isOpen,
  logId,
  onClose,
  organizationId,
  projectId,
}: LogEntriesUploadModalProps) {
  const [selectedUploadType, setSelectedUploadType] = useState<UploadType>();

  const handleClose = useCallback(() => {
    setSelectedUploadType(undefined);
    onClose();
  }, [onClose]);

  if (!isOpen) return null;

  if (!selectedUploadType) {
    return (
      <LogEntriesSelectUploadTypeModal
        organizationId={organizationId}
        onClose={onClose}
        setSelectedUploadType={setSelectedUploadType}
      />
    );
  }

  if (selectedUploadType === UploadType.EDP_AI_UPLOADER) {
    return (
      <LogEntriesImageUploadModal
        logId={logId}
        isOpen={isOpen}
        onClose={handleClose}
        organizationId={organizationId}
        projectId={projectId}
      />
    );
  }
  return (
    <LogEntriesUploadCsvModal
      logId={logId}
      isOpen={isOpen}
      onClose={handleClose}
      organizationId={organizationId}
      projectId={projectId}
    />
  );
}
